import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetGenderedCards} from '../utils/useGetGenderedCards';
import {CardsSliderLoading} from './CardsSliderLoading';
import {CardsSliderView, CardsSliderViewProps} from './CardsSliderView';
import {HeightCalcWrapper} from './HeightCalcWrapper';

export const CardsSlider: React.FC<CardsSliderViewProps> = props => {
  return (
    <HeightCalcWrapper>
      <DataFetcher
        request={useGetGenderedCards()}
        Error={null}
        Loading={CardsSliderLoading}
        View={CardsSliderView}
        viewProps={props}
      />
    </HeightCalcWrapper>
  );
};
